import { Button, Divider, Grid } from "@mui/material";
import { useMemo } from "react";
import DialogHeader from "@entrilia/shared/components/dialog/DialogHeader";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import type { Dashboard } from "../../../../api/types/dashboardsTypes";
import type { SelectedCompanyTile } from "../hooks/validationStateSlice";
import { isSmartViewWidget } from "../models/isTileObjectSmartView";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import CopyDashboardContent from "./components/validating-step/CopyDashboardContent";
import type { DashboardValidationType } from "./hooks/useDashboardValidation";

interface Props {
  dashboards: Dashboard[];
  dashboardValidation: DashboardValidationType;
  copyConditionValues: boolean;
  onCopy: () => void;
  onClose: () => void;
  onCopyConditionValues: (value: boolean) => void;
}
export function CopyToDialogSelection({
  dashboards,
  dashboardValidation,
  copyConditionValues,
  onCopy,
  onClose,
  onCopyConditionValues,
}: Props) {
  const copyAvailable = useMemo(
    () =>
      dashboardValidation.selectedCompanies.length > 0 &&
      dashboardValidation.selectedCompanies.every((c) => c.dashboards.every((r) => r.tiles.every(isValid))),
    [dashboardValidation]
  );

  const header = useMemo(() => {
    if (dashboards.length > 1) {
      return `Copy ${pluralize("Dashboard", dashboards.length)}`;
    }
    return `Copy Dashboard: ${dashboards[0]!.nameUserInput}`;
  }, [dashboards]);

  return (
    <>
      <DialogHeader text={header} onClose={onClose} />
      <Divider />
      <Grid container sx={{ flex: 1, width: "100%" }}>
        <CopyDashboardContent
          validation={dashboardValidation}
          copyConditionValues={copyConditionValues}
          onCopyConditionValues={onCopyConditionValues}
        />
      </Grid>
      <Divider />
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" disabled={!copyAvailable} onClick={onCopy}>
          Copy {pluralize("Dashboard", dashboards.length)}
        </Button>
      </DialogButtons>
    </>
  );
}

const isValid = (dashboardValidation: SelectedCompanyTile) => {
  if (isSmartViewWidget(dashboardValidation.tile.widget)) {
    return dashboardValidation.validated && dashboardValidation.result?.hasRequiredDataset;
  }
  return dashboardValidation.validated;
};
